import cn from 'classnames'
import {Icon} from 'src/common/Icon'

export const CheckIconVariation = ({variant}: {variant: 'neon' | 'grey' | 'green-bg'}) => (
  <div
    className={cn('flex size-4 shrink-0 items-center justify-center rounded-full', {
      'bg-green-neon': variant === 'neon',
      'bg-moss-grey-100': variant === 'grey',
      'bg-[#FFFFFF4D]': variant === 'green-bg',
    })}
  >
    <Icon
      name="check-mark"
      className={cn('size-[9px]', {
        'text-moss-black': variant !== 'green-bg',
        'text-moss-white': variant === 'green-bg',
      })}
    />
  </div>
)
